const actions = {
  SET_STATE: 'cogniableassessment/SET_STATE',
  LOAD_DATA: 'cogniableassessment/LOAD_DATA',
  CREATE_ASSESSMENT: 'cogniableassessment/CREATE_ASSESSMENT',
  LOAD_ASSESSMENT_OBJECT: 'cogniableassessment/LOAD_ASSESSMENT_OBJECT',
  RECORD_RESPONSE: 'cogniableassessment/RECORD_RESPONSE',
  RECORD_AREA_RESPONSE: 'cogniableassessment/RECORD_AREA_RESPONSE',
  END_ASSESSMENT: 'cogniableassessment/END_ASSESSMENT',
  END_QUESTIONS: 'cogniableassessment/END_QUESTIONS',
  CHANGE_QUESTION: 'cogniableassessment/CHANGE_QUESTION',
  UPDATE_QUESTION_RESPONSE: 'cogniableassessment/UPDATE_QUESTION_RESPONSE',
  MAKE_INACTIVE: 'cogniableassessment/MAKE_INACTIVE',
  
}

export default actions
